import { z } from 'zod';

export const resubmissionMonthSchema = z.object({
  rezept_yearmonth_str: z
    .string()
    .min(1, '日付を入力してください。')
    .regex(/^(明治|大正|昭和|平成|令和)\d{2}年\d{2}月$/, '日付を正しく入力してください。'),
});

export type ResubmissionMonthFormValues = z.infer<typeof resubmissionMonthSchema>;
